import { ArrowBack } from '@mui/icons-material'
import {
  Box,
  Container,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AccountStats from '../components/account/stats'

export default function AccountStatsView() {
  const navigate = useNavigate()

  return (
    <Container maxWidth="sm" sx={{ position: 'relative' }}>
      <Box sx={{ height: 16 }} />
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <IconButton aria-label="tillbaka" onClick={() => navigate(-1)}>
          <ArrowBack />
        </IconButton>
        <Box>
          <Typography variant="h6" component="h1">
            Statistik
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Baserat på dina bokade pass
          </Typography>
        </Box>
      </Stack>
      <AccountStats />
      <Box sx={{ height: 64 }} />
    </Container>
  )
}
